import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CustomSpinner from "./views/ComponentCreator/CustomSpinner";
import './App.scss';
const loading = () => <CustomSpinner></CustomSpinner>;

// Containers
const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/Pages/Login'));
const Page404 = React.lazy(() => import('./views/Pages/Page404'));
const PageNoPermission = React.lazy(() => import('./views/Pages/PageNoPermission'));

class App extends Component {

  render() {
    return (
      <BrowserRouter>
          <React.Suspense fallback={loading()}>
            <Switch>
              <Route exact path="/login" name="Login Page" render={props => <Login {...props}/>} />
              <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
              <Route exact path="/no-permission" name="No Permission" render={props => <PageNoPermission {...props}/>} />
              <Route path="/" name="Home" render={props => <DefaultLayout {...props}/>} />
            </Switch>
          </React.Suspense>
      </BrowserRouter>
    );
  }
}

export default App;
